var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.667,
    height: 30.012,
    viewBox: "0 0 32.667 30.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-warning",
    "data-name": "Icon metro-warning",
    d: "M18.9,4.647,32.593,29.712H5.215L18.9,4.647Zm0-2.719a2.363,2.363,0,0,0-1.942,1.309L3.019,28.768c-1.068,1.745-.16,3.172,2.019,3.172H32.77c2.179,0,3.088-1.428,2.019-3.172h0L20.846,3.237A2.363,2.363,0,0,0,18.9,1.928Zm2.042,24.385A2.049,2.049,0,1,1,18.9,24.437,1.964,1.964,0,0,1,20.946,26.313ZM18.9,22.561a1.964,1.964,0,0,1-2.042-1.876V15.058a2.049,2.049,0,0,1,4.083,0v5.627A1.964,1.964,0,0,1,18.9,22.561Z",
    transform: "translate(-2.571 -1.928)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlack);
export default __webpack_public_path__ + "static/media/warning-black.cbd04c06e53aba875dee906f0c848f0c.svg";
export { ForwardRef as ReactComponent };